module.exports = __webpack_public_path__ + "static/img/14000357.6ca38a9c.png";